import * as React from 'react';
import { FC, PropsWithChildren } from 'react';
import { CookiesProvider } from 'react-cookie';
import { NavigationRailContent } from './navigation-rail-content';

export interface NavigationRailItem {
    link: string;
    icon: React.ReactNode;
    text: string;
}

export interface PublisherLinkOverrides {
    categories: string;
    distributions: string;
    experiments: string;
    calendar: string;
    selections: string;
    gameEnvironments: string;
    gameVersions: string;
}

export interface NavigationRailPropsType {
    toolId: string;
    navigationRailItems?: NavigationRailItem[];
    publisherLinkOverrides?: PublisherLinkOverrides;
    hostedInPortal?: boolean;
    hostedInToolId?: string;
}

export const NavigationRail: FC<PropsWithChildren<NavigationRailPropsType>> = (props) => {

    return (
        <CookiesProvider>
            <NavigationRailContent
                toolId={props.toolId}
                navigationRailItems={props.navigationRailItems}
                publisherLinkOverrides={props.publisherLinkOverrides}
                hostedInPortal={props.hostedInPortal}
                hostedInToolId={props.hostedInToolId}
            />
        </CookiesProvider>
    );
};

